import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "vendor-program-detail" */
      './VendorProgram'
    )
);
